<template>
  <div class="coins-hist">
    <van-sticky :offset-top="0">
      <div style="background-color: #F7F8FA;">
        <div class="banner">
          <div class="bg-div">
            <div class="title">可用邀工币</div>
            <div class="num">{{ coin }}</div>
            <div class="info">邀工币可用于购买邀工网内各项服务</div>
          </div>
        </div>

        <van-tabs v-model="active" @click="tabClick" title-active-color="#096CEFFF">
          <van-tab v-for="(item, index) in evaluateTitleList" :key="index" :name="item.name" :title="item.title">
          </van-tab>
        </van-tabs>
      </div>
    </van-sticky>

    <template v-if="active == 0">
      <div class="tab1 list-content">
        <div class="coins-list">
          <van-cell-group>
            <div class="van-cell van-cell--center" v-if="payOpen == 1">
              <div class="van-cell__title">
                <span class="title">现金充值</span>
                <div class="van-cell__label">充值越多，折扣越大</div>
              </div>
              <div class="van-cell__value">
                <van-button class="tab1-btn" round color="#096CEFFF" @click.stop="coinsPay">去充值</van-button>
              </div>
            </div>

            <div class="van-cell van-cell--center">
              <div class="van-cell__title">
                <span class="title">积分兑换</span>
                <div class="van-cell__label">积分可兑换邀工币</div>
              </div>
              <div class="van-cell__value">
                <van-button class="tab1-btn" round color="#096CEFFF" @click="toIntegralMall">去兑换</van-button>
              </div>
            </div>

            <div class="van-cell van-cell--center">
              <div class="van-cell__title">
                <span class="title">分享获取</span>
                <div class="van-cell__label">邀请工友一起使用赠送</div>
              </div>
              <div class="van-cell__value">
                <van-button class="tab1-btn" round color="#096CEFFF" @click="toShare">去分享</van-button>
              </div>
            </div>

          </van-cell-group>
        </div>
      </div>
    </template>

    <template v-if="active == 1">
      <div v-if="list.length === 0 && !incomeListLoading" class="noContent">
        <img src="../../assets/images/blank_icon_project.png">
        <div class="blank-tip">暂无记录</div>
      </div>

      <div v-else class="list-content">
        <van-list
          v-model="incomeListLoading"
          :finished="listLoadFinished"
          @load="onLoad"
        >

          <div class="coins-list">
            <van-cell-group>
              <div class="van-cell van-cell--center coins-list-cell" v-for="(item, index) in list" :key="index">
                <div class="van-cell__title">
                  <span class="title">{{ item.operate }}</span>
                  <div class="van-cell__label">{{ item.createTime }}</div>
                </div>
                <div class="van-cell__value">
                  <span style="color:#333;" v-if="active==1">+ </span>
                  <span style="color:#333;" v-else>- </span>
                  <span style="color:#FFB111FF;">{{ item.coin }}</span>
                </div>
                <span class="icon_invalid" v-show="item.expire === 1"></span>
              </div>
            </van-cell-group>
          </div>
        </van-list>
      </div>

      <div class="bottom-btn" v-if="payOpen == 1">
        <van-button round size="normal" color="#096CEFFF" @click.stop="coinsPay" block>立即充值
        </van-button>
      </div>
    </template>

    <template v-if="active == 2">
      <div v-if="list1.length === 0 && !incomeListLoading" class="noContent">
        <img src="../../assets/images/blank_icon_project.png">
        <div class="blank-tip">暂无记录</div>
      </div>

      <div v-else class="list-content">
        <van-list
          v-model="incomeListLoading"
          :finished="listLoadFinished"
          @load="onLoad"
        >

          <div class="coins-list">
            <van-cell-group>
              <div class="van-cell van-cell--center coins-list-cell" v-for="(item, index) in list1" :key="index">
                <div class="van-cell__title">
                  <span class="title">{{ item.operate }}</span>
                  <div class="van-cell__label">{{ item.createTime }}</div>
                </div>
                <div class="van-cell__value">
                  <span style="color:#333;" v-if="active==1">+ </span>
                  <span style="color:#333;" v-else>- </span>
                  <span style="color:#FFB111FF;">{{ item.coin }}</span>
                </div>
                <span class="icon_invalid" v-show="item.expire === 1"></span>
              </div>
            </van-cell-group>
          </div>
        </van-list>
      </div>

      <div class="bottom-btn" v-if="payOpen == 1">
        <van-button round size="normal" color="#096CEFFF" @click.stop="coinsPay" block>立即充值
        </van-button>
      </div>

    </template>

    <van-overlay :show="shareShow" @click="shareShow = false" z-index="999">
      <div class="share-popup" @click.stop>
        <van-icon color="#d3d3d3" style="float: right" name="close" @click="shareShow=false"/>
        <div class="share-popup-content">
          <div class="share-title">
            每邀请一位工友点击使用邀工网，即可获得5个邀工币
          </div>
          <div class="share-tip" style="text-align: center;color: #999999FF">
            分享到
          </div>
          <div class="share-icon" style="text-align: center">
            <van-row>
              <van-col span="8" @click="toWechat">
                <img src="../../assets/images/coins/share_icon_wechat.png">
                <div class="text">微信</div>
              </van-col>
              <van-col span="8" @click="toPengyouquan">
                <img src="../../assets/images/coins/share_icon_pengyouquan.png">
                <div class="text">朋友圈</div>
              </van-col>
              <van-col span="8" @click="toMianduimian">
                <img src="../../assets/images/coins/share_icon_mianduimian.png">
                <div class="text">我的推广码</div>
              </van-col>
            </van-row>
          </div>
          <div class="share-tip" style="text-align: center">
            <a @click="toInvitationRule">
              <van-icon name="question-o"/>
              邀请好友规则
            </a>
          </div>
        </div>
      </div>
    </van-overlay>

    <div class="floatball" id="floatball"
         v-if="active != 0 && this.$route.query.fromPay !== 'pay'" @click="toShare"
         @touchmove.prevent @mousewheel.prevent
         @mousedown.stop="down" @touchstart.stop="down"
         @mousemove.stop="move" @touchmove.stop="move"
         @mouseup.stop="end" @touchend.stop="end"
         :style="{top:position.y+'px', left:position.x+'px'}">
      <!--      奖励规则-->
    </div>
  </div>
</template>

<script>
import { getCryptoPhone } from '@api/activity'
import { coinRecord, getNo, payOpen } from '@api/coins'
import { getCoinListByRecommend } from '@api/activity'

// 鼠标位置和div的左上角位置 差值
var dx, dy
var screenWidth = window.screen.width
var screenHeight = window.screen.height

export default {
  name: 'coins-hist',
  components: {},
  data () {
    return {
      shareShow: false,
      active: '0',
      evaluateTitleList: [
        { name: '0', title: '获取方式' },
        { name: '1', title: '获取记录' },
        { name: '2', title: '使用记录' }
      ],
      pageSize: 10,
      pageNum: 0,
      pageNum1: 0,
      incomeListLoading: false,
      listLoadFinished: false,
      list: [],
      list1: [],
      coin: 0,
      payOpen: undefined,

      flags: false,
      position: {
        x: 270,
        y: 485
      },
      cryptoPhone: ''
    }
  },
  created () {
    // 获取邀功币数量
    this.getCoinNum()
    if (this.$route.query.fromPay === 'pay') {
      this.active = '1'
      this.evaluateTitleList =
        [
          { name: '1', title: '获取记录' },
          { name: '2', title: '使用记录' }
        ]
      // 获取记录
      this.pageNum = 0
      this.list = []
      this.incomeListLoading = true
      this.listLoadFinished = false
      this.coinRecord()
    } else {
      this.evaluateTitleList =
        [
          { name: '0', title: '获取方式' },
          { name: '1', title: '获取记录' },
          { name: '2', title: '使用记录' }
        ]
      // 充值开关
      this.getPayOpen()

      this.getCryptoPhone()
      // 获取记录
      // this.coinRecord()
    }
  },
  methods: {

    // 获取用户加密手机号（用于分享）
    getCryptoPhone () {
      getCryptoPhone().then(res => {
        if (res.data.code === 200) {
          this.cryptoPhone = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 跳转商城首页
    toIntegralMall () {
      // this.enterRouter('coinsInvitation')
      const data = {
        title: '积分商城',
        url: `${process.env.VUE_APP_BASE_HOST}/integralMallList`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },

    // 去分享
    toShare () {
      getCoinListByRecommend({
        pageNum: 1,
        pageSize: 1
      }).then(res => {
        if (res.data.code === 200) {
          this.incomeListLoading = false
          if (res.data.data.totalRows > 0) {
            const data = {
              title: '分享赚邀工币',
              url: `${process.env.VUE_APP_BASE_HOST}/inviteFriends`
            }
            this.$bridge.callHandler('newPage', data, response => {
              console.log('response:', response)
            })
          } else {
            this.shareShow = true
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })

    },

    // 分享微信
    toWechat () {
      // alert('分享微信')
      const data = {
        title: '邀请下载',
        content: '邀请您和我一起使用邀工网，发活、找活一键触达',
        type: 0,//0-微信；1-朋友圈
        path: '/pages/getJob/index?cryptoMobile=' + this.cryptoPhone,//小程序地址
        url: '/coinsInvitation',
      }
      this.$bridge.callHandler('inviteFriend', data, response => {
        console.log('response:', response)
      })
    },

    // 分享朋友圈
    toPengyouquan () {
      // alert('分享朋友圈')
      const data = {
        title: '邀请您和我一起使用邀工网，发活、找活一键触达',
        content: '邀请您和我一起使用邀工网，发活、找活一键触达',
        type: 1,//0-微信；1-朋友圈
        path: '/pages/getJob/index?cryptoMobile=' + this.cryptoPhone,//小程序地址
        url: '/coinsInvitation',
      }
      this.$bridge.callHandler('inviteFriend', data, response => {
        console.log('response:', response)
      })
    },

    // 面对面分享
    toMianduimian () {
      // this.enterRouter('coinsInvitation')
      const data = {
        title: '邀工网',
        url: `${process.env.VUE_APP_BASE_HOST}/coinsInvitation`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },

    // 跳转邀请好友规则
    toInvitationRule () {
      const data = {
        title: '邀请好友规则',
        url: `${process.env.VUE_APP_BASE_HOST}/staticPages/invitationRule`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },

    // 实现移动端拖拽
    down (event) {
      this.flags = true
      var touch
      if (event.touches) {
        touch = event.touches[0]
      } else {
        touch = event
      }
      dx = touch.clientX - event.target.offsetLeft
      dy = touch.clientY - event.target.offsetTop
    },
    move () {
      if (this.flags) {
        var touch
        if (event.touches) {
          touch = event.touches[0]
        } else {
          touch = event
        }
        // 定位滑块的位置
        this.position.x = touch.clientX - dx
        this.position.y = touch.clientY - dy
        // 限制滑块超出页面
        // console.log('屏幕大小', screenWidth, screenHeight )
        if (this.position.x < 0) {
          this.position.x = 0
        } else if (this.position.x > screenWidth - touch.target.clientWidth) {
          this.position.x = screenWidth - touch.target.clientWidth
        }
        if (this.position.y < 0) {
          this.position.y = 0
        } else if (this.position.y > screenHeight - touch.target.clientHeight) {
          this.position.y = screenHeight - touch.target.clientHeight
        }
        //阻止页面的滑动默认事件
        document.addEventListener('touchmove', function () {
          event.preventDefault()
        }, false)
      }
    },
    //鼠标释放时候的函数
    end () {
      console.log('end')
      this.flags = false
    },

    // 获取开关状态
    getPayOpen () {
      let deviceType
      // 判断ios还是安卓
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isiOS) {
        deviceType = 'IOS'
      } else {
        deviceType = 'ANDROID'
      }
      payOpen(deviceType).then(res => {
        if (res.data.code === 200) {
          this.payOpen = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 去支付
    coinsPay () {
      const data = {
        title: '邀工币充值',
        url: `${process.env.VUE_APP_BASE_HOST}/coinsPay`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },

    onLoad () {
      if (this.active == 1) {
        this.coinRecord()
      } else if (this.active == 2) {
        this.coinRecord1()
      }
    },

    tabClick (e) {
      if (e == 0) {
        return
      } else if (e == 1) {
        this.pageNum = 0
        this.list = []
        this.incomeListLoading = true
        this.listLoadFinished = false
        this.coinRecord()
        return
      } else if (e == 2) {
        this.pageNum1 = 0
        this.list1 = []
        this.incomeListLoading = true
        this.listLoadFinished = false
        this.coinRecord1()
      }
      // this.pageNum = 0
      // this.list = []
      // this.incomeListLoading = true
      // this.listLoadFinished = false
      // this.coinRecord()
    },

    // 获取邀工币数量
    getCoinNum () {
      getNo().then(res => {
        if (res.data.code === 200) {
          this.coin = res.data.data.coin
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 获取历史记录
    coinRecord () {
      this.pageNum++
      this.incomeListLoading = true
      coinRecord({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        type: this.active
      }).then(res => {
        if (res.data.code === 200) {
          this.incomeListLoading = false
          if (res.data.data.rows && res.data.data.rows.length === 0) {
            this.listLoadFinished = true
          } else {
            this.list = this.list.concat(res.data.data.rows)
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 获取历史记录
    coinRecord1 () {
      this.pageNum1++
      this.incomeListLoading = true
      coinRecord({
        pageNum: this.pageNum1,
        pageSize: this.pageSize,
        type: this.active
      }).then(res => {
        if (res.data.code === 200) {
          this.incomeListLoading = false
          if (res.data.data.rows && res.data.data.rows.length === 0) {
            this.listLoadFinished = true
          } else {
            this.list1 = this.list1.concat(res.data.data.rows)
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">

//.van-tab--active {
//  color: #096CEFFF !important;
//}

.floatball {
  padding: 20px;
  color: white;
  height: 100px;
  width: 100px;
  //padding: 5px;
  z-index: 2;
  position: fixed;
  background-size: contain;
  //background-color: rgba(29, 157, 237, 0.8);
  //background-image: url('../../assets/images/coins/coins_share.png');
  background-image: url('../../assets/images/coins/btn_share.png');
}

.share-popup {
  margin: 30% auto;
  background-size: contain;
  width: 300px;
  height: 375px;
  background-image: url('../../assets/images/coins/coins_share.png');

  .share-popup-content {
    padding: 10px 20px;
  }

  .share-title {
    font-size: 16px;
    padding-top: 130px;
  }

  .share-icon {
    padding-top: 20px;

    img {
      margin: auto;
      height: 50px;
      width: 50px;
    }

    .text {
      margin-top: 5px;
      font-size: 14px;
    }
  }

  .share-tip {
    font-size: 14px;
    padding-top: 20px;
  }

  .van-icon {
    vertical-align: -10%
  }
}

.tab1 {
  .van-cell__title {
    margin: 13px 0;

    .van-cell__label {
      padding-top: 4px;
    }
  }

  .tab1-btn {
    font-size: 14px;
    height: 28px;
    width: 75px;
  }
}

.title {
  font-weight: bold;
  font-size: 16px;
}

#app {
  background-color: #fff;
}

.list-content {
  padding-bottom: 70px;
}

.coins-hist {

  .banner {
    padding: 10px;
  }

  .coins-list {
    //background-color: #fff;
    width: 100%;

    .coins-list-cell {
      position: relative;
    }

    .icon_invalid {
      width: 40px;
      height: 40px;
      background: url("../../assets/images/coins/icon_invalid.png") center no-repeat;
      background-size: contain;
      position: absolute;
      right: 0;
      top: 0;
    }

  }

  .bg-div {
    padding: 20px;
    width: 100%;
    height: 147px;
    background: url('../../assets/images/coins/yaogongbi_bg.png');
    background-size: contain;
    color: white;

    .title {
      line-height: 20px;
      font-size: 17px;
    }

    .num {
      line-height: 70px;
      font-size: 30px;
    }

    .info {
      line-height: 20px;
      font-size: 14px;
    }
  }

  .van-cell {

    padding-left: 15px;
    padding-right: 15px;
    display: flex;

    .van-cell__label {
      font-size: 14px !important;
    }

    .van-cell__value {
      flex-grow: 0.3;
      text-align: right;
    }
  }

  .van-cell:not(:last-child)::after {
    display: inline;
  }
}
</style>
